import React from 'react';
import styled from '@emotion/styled';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { AboutService } from 'ui/components/company/features/AboutService';
import { useModal } from 'ui/components/screens/modals/useModal';
import { CompanyNameSearch } from 'ui/components/screens/modals/CompanyNameSearch/CompanyNameSearch';
import { TemplateModal } from 'ui/components/screens/modals/TemplateModal/TemplateModal';
import { useCompanyEdit } from './useCompanyEdit';
import { TopOfferSellers } from './TopOfferSellers';
import { mqUser } from 'utils/responsive';
import { CompanyEditForm } from '../CompanyEditForm/CompanyEditForm';

const BgWrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom; 40px;
`;

export const CompanyEdit: React.FC = () => {
    const {
        control,
        loading,
        errors,
        areaChoices,
        filteredPrefectureChoices,
        employeeChoices,
        revenueChoices,
        industryChoices,
        profitLevelChoices,
        netAssetsLevelChoices,
        notRegistrationComplete,
        showSnackbar,
        editing,
        user,
        companies,
        snackBarMessage,
        setEditing,
        setShowSnackbar,
        onCompanySelect,
        submit,
        setValue,
        watch,
        unPublish,
        reOpen,
    } = useCompanyEdit();

    const companySearchModal = useModal();
    const templateModal = useModal();

    const handleSelectTemplate = (text: string) => {
        const currentQuestion = watch('question') || '';
        if (currentQuestion.trim()) {
            setValue('question', currentQuestion + '\n' + text);
        } else {
            setValue('question', text);
        }
    };

    if (!user) {
        return null;
    }

    const descriptions: { [key: string]: string[] } = {
        説明: [
            notRegistrationComplete
                ? '企業プロフィールを完成させて仲介会社からのオファー率をアップさせましょう'
                : 'オファーが来ない場合は、企業情報を修正して魅力的な文章を書きましょう',
        ],
    };
    return (
        <BgWrapper>
            {companySearchModal.createModal(
                <CompanyNameSearch
                    onSelect={(company) => onCompanySelect(company)}
                    closeModal={companySearchModal.closeModal}
                />,
                { scrollable: false },
            )}
            {templateModal.createModal(
                <TemplateModal
                    onSelect={handleSelectTemplate}
                    onClose={templateModal.closeModal}
                    companyType="company"
                />,
                {
                    keyboard: true,
                    maskClosable: true,
                    onClose: templateModal.closeModal,
                },
            )}
            <Wrapper>
                <SnackBar message={snackBarMessage} open={showSnackbar} setOpen={setShowSnackbar} />
                <div>
                    <PageTitle title="企業プロフィール" />
                    <AboutService descriptions={descriptions} />
                </div>
                <CompanyEditForm
                    user={user}
                    control={control}
                    loading={loading}
                    errors={errors}
                    areaChoices={areaChoices}
                    employeeChoices={employeeChoices}
                    revenueChoices={revenueChoices}
                    industryChoices={industryChoices}
                    netAssetsLevelChoices={netAssetsLevelChoices}
                    filteredPrefectureChoices={filteredPrefectureChoices}
                    profitLevelChoices={profitLevelChoices}
                    editing={editing}
                    submit={submit}
                    setValue={setValue}
                    watch={watch}
                    onCompanySelect={onCompanySelect}
                    setEditing={setEditing}
                    unPublish={unPublish}
                    reOpen={reOpen}
                    showSnackbar={showSnackbar}
                    setShowSnackbar={setShowSnackbar}
                />
                {!editing && <TopOfferSellers companies={companies} />}
            </Wrapper>
        </BgWrapper>
    );
};
